export default __webpack_public_path__ + "static/media/404.62b19e75.svg";